module.exports = __webpack_public_path__ + "static/media/wrong.d29b0c69.png";